import { useContext, useEffect, useRef, useState } from "react";
import Grid from "../../components/components/Grid/Grid";
import './CustomerTasks.scss'
import { Button, Column, Icon, Row, Select } from "../../components";
import DropDownWithLabelInline from "../../shared/components/input/DropDownWithLabelInline";
import { SelectOption } from "../../shared/components/input";
import Logger from "../../shared/services/Logger";
import { toast } from "react-toastify";
import { CustomerTaskDtoReadExtended } from "../model/CustomerTaskDtoRead";
import CustomerTaskViewService from "./CustomerTasksViewService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../shared/store";
import { updateLookupData } from "../customer-slice/Customer-lookup-slice";
import { CustomerTaskConstants, SlicerLookUpConstant } from "../../shared/util/constant";
import { AppEvenType, clearAppEvent } from "../../shared/store/component-notification/ComponentNotification";
import { TaskScreenLables } from "../../shared/util/label";
import { CustomerFilterViewMoel } from "../model/CustomerFilterViewModel";
import CutomerMainPortalHeaderService from "../customer-main-portal/CutomerMainPortalHeaderService";
import SliderTaskService from "../customer-slider-content/slider-task/SliderTaskService";
import { CommonUtility } from "../../Services/CommonUtility";
import CustomerActivityService from "../customer-activity/CustomerActivityService";
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import AppContext from "../../shared/components/AppContext";
import EntityHistoryViewer from "../../shared/components/entity-history/EntityHistoryViewer";
import EntityHistoryModel from "../model/EntityHistoryModel";
import { AbilityContext } from "../../shared/abilities/AbilityContext";
import * as constant from '../../shared/util/constant';
import { Container } from "react-bootstrap";
import {  storeCustomerPoliciesForDropdown } from "../../../src/customer/customer-slice/Customer-slice"
import { setCustomerSummary } from '../customer-slice/Customer-slice';

export interface ICustomerTask {
    customerId?: string,
    onRouteChange?: (tabKey: string) => void,
    navigateTo?: (path: string) => void
};

/// Move it to TaskScreenLables, once changes are merged
export const TaskScreenLables_Additional = {
    addTasks: "ADD TASKS"
}

interface ITaskGridComponentState {
    customerTasks: CustomerTaskDtoReadExtended[],
    gridColumns: any[],
    taskStatusList: SelectOption[],
    taskTypeList: SelectOption[],
    taskPriorityList: SelectOption[],
    policiesForSelect: SelectOption[],
    taskStatusId: string,
    taskTypeId: string,
    taskPriorityId: string,
    isRowDataAddedOrEdited: boolean,
    customerSummary: CustomerFilterViewMoel,
    showTaskHistory: boolean,
    taskHistoryData: EntityHistoryModel[],
    historyDialogTitle: string
}

const taskGridComponentInitData: ITaskGridComponentState = {
    customerTasks: [],
    gridColumns: [],
    taskStatusList: [],
    taskTypeList: [],
    taskPriorityList: [],
    policiesForSelect: [],
    taskStatusId: '',
    taskTypeId: '',
    taskPriorityId: '',
    isRowDataAddedOrEdited: false,
    customerSummary: {},
    showTaskHistory: false,
    taskHistoryData: [],
    historyDialogTitle: ''
}

const CustomerTasksView: React.FunctionComponent<ICustomerTask> = (props) => {
    const dispatch = useDispatch();
    const appContext = useContext(AppContext);
    const customerTaskService = new CustomerTaskViewService();
    const sliderTaskService = new SliderTaskService();
    const cutomerMainPortalHeaderService = new CutomerMainPortalHeaderService();
    const customerActivityService = new CustomerActivityService();

    const taskTypes = useSelector((state: RootState) => state?.LookupState.activityTypeList);
    const taskPriorities = useSelector((state: RootState) => state?.LookupState.taskPriorityList);
    const taskStatuses = useSelector((state: RootState) => state?.LookupState.taskStatusList);
    const empList = useSelector((state: RootState) => state?.LookupState.employeeList);
    const companyList = useSelector((state: RootState) => state?.LookupState.companyList);
    const customerInfo = useSelector((state: RootState) => state?.customerSlice);
    const [customerOptions, setCustomerOptions] = useState<SelectOption[]>([]);
    const eventState = useSelector((state: RootState) => state?.eventState);
    const userDetails = useSelector((state: any) => state.userContextSlice);

    const ab_subject = "Customer Task";
    const ability = useContext(AbilityContext);
    const canUserCreateCustomerTask = ability.can('create', ab_subject, constant.ScreenName.CUSTOMER_TASK);
    const canUserEditCustomerTask = ability.can('update', "Customer Task", constant.ScreenName.CUSTOMER_TASK);

    const modalContext = useConfirmationModalContext();

    const [taskGridComponentState, setTaskGridComponentState] = useState<ITaskGridComponentState>(taskGridComponentInitData);

    const [historyGridColumns, setHistoryGridColumns] = useState<any[]>([]);

    const [navigateToFirstPage, setNavigateToFirstPage] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [fetchLatestTaskAt, setFetchLatestTaskAt] = useState(new Date());

    const { customerTasks
        , gridColumns
        , taskStatusList
        , taskTypeList
        , taskPriorityList
        , policiesForSelect
        , taskStatusId
        , taskTypeId
        , taskPriorityId } = taskGridComponentState;

    const policiesRef = useRef(policiesForSelect);
    useEffect(() => { policiesRef.current = policiesForSelect; }, [policiesForSelect]);

    const TaskDashboardSlice = useSelector((state: RootState) => state?.taskDashboard);
    const [isTaskEditChecked,setIsTaskEditChecked] = useState(false)

    const gridRef = useRef<any>(null);
    useEffect(()=>{
        if(canUserEditCustomerTask && TaskDashboardSlice.taskId != null && !isTaskEditChecked && customerTasks.length >0){
           
            setIsTaskEditChecked(true);

            let rowToEdit = customerTasks.find(x=>x.id == TaskDashboardSlice.taskId);
            
            //to goto correct page where row exists
            let sortedArray = [...customerTasks].sort((a,b)=> b.dueDate - a.dueDate);
            let itemIndex = sortedArray.findIndex(x=>x.id == TaskDashboardSlice.taskId);
            let defaultPageSize = 10;
            if(itemIndex != 0){
                let pageIndex = Math.floor(itemIndex/defaultPageSize)
                gridRef.current.gotoPage(pageIndex);

            }else{
                gridRef.current.gotoPage(0);
            }

            taskGridCellClickHandler(rowToEdit, null,'edit_row');
            
            //to set the focus to description field
            let d = document.getElementsByClassName("description-cell-edit");
            setTimeout(()=>{d[0].focus();},100);

        }       
    },[customerTasks])

    useEffect(() => {
        initializeComponent();
    }, []);


    useEffect(() => {
        if (eventState.eventType == AppEvenType.NewTaskCreated) {
            fetchTasks();
            dispatch(clearAppEvent());
        }
    }, [eventState.eventType]);

    useEffect(() => {

        appContext.formSavedStatus = !taskGridComponentState.isRowDataAddedOrEdited
    }, [taskGridComponentState.isRowDataAddedOrEdited]);

    const initializeComponent = async () => {
        try {
            setHistoryGridColumns(customerTaskService.getHistoryGridColumns());

            let tskStatusList = [];
            let tskPriorityList = [];
            let tskTaskTypeList = [];
            let emplSelectList = [];
            let compSelectList = [];
            let custOptions = [];

            let taskGridColumns = customerTaskService.getTaskGridColumns(onTaskGridOriginalRowDataChange, onEditingCellDataChange, props.onRouteChange, taskGridCellClickHandler, tskStatusList, tskPriorityList, tskTaskTypeList, emplSelectList, policiesForSelect, compSelectList, custOptions, canUserEditCustomerTask);
            setTaskGridComponentState(compState => { return { ...compState, gridColumns: taskGridColumns }; });

            if (!taskTypes || taskTypes.length == 0) {
                tskTaskTypeList = await customerTaskService.getTaskTypeList();
                dispatch(updateLookupData({ data: tskTaskTypeList, type: SlicerLookUpConstant.ACTIVITY_TYPE }));
            }
            else {
                tskTaskTypeList = [...taskTypes];
            }

            if (!taskPriorities || taskPriorities.length == 0) {
                tskPriorityList = await customerTaskService.getTaskPriorityList();
                dispatch(updateLookupData({ data: tskPriorityList, type: SlicerLookUpConstant.TASK_PRIORITY }));
            }
            else {
                tskPriorityList = [...taskPriorities];
            }

            if (!taskStatuses || taskStatuses.length == 0) {
                tskStatusList = await customerTaskService.getTaskStatusList();
                dispatch(updateLookupData({ data: tskStatusList, type: SlicerLookUpConstant.TASK_STATUS }));
            }
            else {
                tskStatusList = [...taskStatuses];
            }

            if (!empList || empList.length == 0) {
                emplSelectList = await customerTaskService.getEmployeeList();
                dispatch(updateLookupData({ data: emplSelectList, type: SlicerLookUpConstant.EMPLOYEE_LIST }));
            }
            else {
                emplSelectList = [...empList];
            }

            if (!companyList || companyList.length == 0) {
                compSelectList = await customerTaskService.getCompanyList();
                dispatch(updateLookupData({ data: compSelectList, type: SlicerLookUpConstant.COMPANY_LIST }));
            }
            else {
                compSelectList = [...companyList];
            }

            setTaskGridComponentState(compState => { return { ...compState, taskStatusList: tskStatusList }; });
            setTaskGridComponentState(compState => { return { ...compState, taskTypeList: tskTaskTypeList }; });
            setTaskGridComponentState(compState => { return { ...compState, taskPriorityList: tskPriorityList }; });

            let cst = await cutomerMainPortalHeaderService.getCustomerSummary(props.customerId);

            //let cst;
            //if (customerInfo.customerSummary !== null) {
            //    cst = customerInfo.customerSummary;
            //} else {
            //    cst = await cutomerMainPortalHeaderService.getCustomerSummary(props.customerId);
            //    dispatch(setCustomerSummary(cst));
            //}
            setTaskGridComponentState(compState => { return { ...compState, customerSummary: cst ? cst : {} }; });

            let custPolicyData = await customerActivityService.getPoliciesForCustomer(props.customerId);


            //let custPolicyData;
            //if (customerInfo.policiesForDropdown.length === 0 || customerInfo.policiesForDropdown.length === undefined) {
            //    custPolicyData = await customerActivityService.getPoliciesForCustomer(props.customerId);
            //    dispatch(storeCustomerPoliciesForDropdown(custPolicyData));
            //}
            //else {
            //    custPolicyData = customerInfo.policiesForDropdown;
            //}

            setTaskGridComponentState(compState => { return { ...compState, policiesForSelect: custPolicyData }; });

            if (cst) {
                custOptions = [
                    {
                        label: ((cst.firstName ? cst.firstName : '') + ' ' + (cst.lastName ? cst.lastName : '')).trim(),
                        value: cst.id
                    }
                ];
            }

            setCustomerOptions(custOptions);

            taskGridColumns = customerTaskService.getTaskGridColumns(onTaskGridOriginalRowDataChange, onEditingCellDataChange, props.onRouteChange, taskGridCellClickHandler, tskStatusList, tskPriorityList, tskTaskTypeList, emplSelectList, custPolicyData, compSelectList, custOptions, canUserEditCustomerTask);
            setTaskGridComponentState(compState => { return { ...compState, gridColumns: taskGridColumns }; });

            setIsInitialized(true);
            const defaultStatus = tskStatusList.find((status) => status.label === "Incomplete")?.value;

            setTaskGridComponentState((compState) => ({
                ...compState,
                taskStatusList: tskStatusList,
                taskStatusId: defaultStatus || "",
            }));
        }
        catch (ex) {
            if ((ex.status == 422 && ex.data?.error == CustomerTaskConstants.CUSTOMER_DELETED) || ex.status == 404) {
                toast.error(constant.CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
                return;
            }

            Logger.logError(CustomerTaskConstants.ERROR_WHILE_LOADING_TASK_GRID_PAGE, ex);
            toast.error(CustomerTaskConstants.ERROR_WHILE_LOADING_TASK_GRID_PAGE, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    useEffect(() => {

        if (isInitialized) {
            fetchTasks();
        }
    }, [taskStatusId, taskTypeId, taskPriorityId, fetchLatestTaskAt]);

    const fetchTasks = async () => {
        try {
            let taskData = await customerTaskService.getTasks(props.customerId, taskGridComponentState.taskTypeId, taskGridComponentState.taskStatusId, taskGridComponentState.taskPriorityId);
            
            if (Array.isArray(taskData)) {
                taskData = taskData.map(task => ({
                    ...task,
                    description: task.description == null ? '' : task.description
                }));
            }
            setTaskGridComponentState(compState => { return { ...compState, customerTasks: taskData, isRowDataAddedOrEdited: false }; });
        }
        catch (ex) {
            if (ex.status == 422 && ex.data?.error == CustomerTaskConstants.CUSTOMER_DELETED) {
                toast.error(constant.CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
                return;
            }

            Logger.logError(CustomerTaskConstants.ERROR_WHILE_LOADING_TASK_LIST, ex);
            toast.error(CustomerTaskConstants.ERROR_WHILE_LOADING_TASK_LIST, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const hideTaskHistoryModal = () => {
        setTaskGridComponentState(compState => { return { ...compState, showTaskHistory: false, taskHistoryData: [], historyDialogTitle: '' }; });
    }

    const onComponentStateChange = (propName: string, value: string | Date | boolean) => {
        setTaskGridComponentState(compState => { return { ...compState, [propName]: value }; });
    }

    const onTaskGridOriginalRowDataChange = (originalRow: any, column: any, value: any, additionalInfo: any) => {
        if (additionalInfo == TaskScreenLables.rowexpander) {
            originalRow.isRowExpanded = value;
        }
        else {
            originalRow[column.fieldName] = value;
        }

        setTaskGridComponentState(compState => { return { ...compState, customerTasks: [...compState.customerTasks] }; });
    }

    const onEditingCellDataChange = (editingRow: any, column: any, value: any, additionalInfo: any) => {
        editingRow[column.fieldName] = value;

        setTaskGridComponentState(compState => { return { ...compState, customerTasks: [...compState.customerTasks] }; });
    }

    const onAddTaskButtonClick = () => {
        setTaskGridComponentState(compState => {
            compState.customerTasks.forEach(tsk => {
                tsk.isGridInEditMode = true;
            });
            let newTaskRow = customerTaskService.getNewTaskRow(compState.customerSummary, userDetails, policiesForSelect);
            let newTaskList = [newTaskRow, ...compState.customerTasks];
            return { ...compState, customerTasks: newTaskList, isRowDataAddedOrEdited: true };
        });
        setNavigateToFirstPage(true);
    }

    const taskGridCellClickHandler = (originalRow: CustomerTaskDtoReadExtended, column: any, additionalData: any) => {
        switch (additionalData) {
            case 'save_row':
                saveRowClickHandler(originalRow)
                break;
            case 'cancel_row_editing':
                cancelRowEditingClickHandler(originalRow, column);
                break;
            case 'edit_row':
                editRowClickHandler(originalRow, column);
                break;
            case 'show_task_history':
                showHistory(originalRow);
                break;
            default:
                break;
        }
    }

    const showHistory = async (originalRow) => {
        try {

            let originalRowData: CustomerTaskDtoReadExtended = originalRow;

            let data = await customerTaskService.getTaskHistory(originalRowData.id);

            if (!data || data.length == 0) {
                toast.warn(CustomerTaskConstants.NO_HISTORY_AVAILABLE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }

            let dialogTitle = `${CustomerTaskConstants.TASK_DIALOG_TITLE}${originalRowData.policyNumber ? '  |  #' + originalRowData.policyNumber : ''}  |  ${originalRowData.custDescr}`;

            // Show task history modal.
            setTaskGridComponentState(compState => { return { ...compState, showTaskHistory: true, taskHistoryData: data, historyDialogTitle: dialogTitle }; });
        }
        catch (ex) {
            Logger.logError(CustomerTaskConstants.ERROR_WHILE_FETCHGIN_TASK_HISTORY, ex);
            toast.error(CustomerTaskConstants.ERROR_WHILE_FETCHGIN_TASK_HISTORY, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const saveRowClickHandler = async (originalRow: CustomerTaskDtoReadExtended) => {
        try {
            let editingRow = originalRow.editingRow;
            if (!editingRow) {
                return;
            }
            const isPolicyOptional = !policiesRef.current || policiesRef.current.length === 0;
            let validationError = sliderTaskService.validateTask(originalRow, isPolicyOptional);
            editingRow.errors = validationError;



            if (Object.keys(validationError).length > 0) {
                toast.warn(CustomerTaskConstants.FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }

            let taskPolicy = policiesForSelect?.find(item => item.value == editingRow.polId);
            let taskRequestDto = sliderTaskService.getTaskRequestDto(editingRow, taskPolicy?.originalData?.polEffDate);

            if (!taskRequestDto.id) {
                await sliderTaskService.createTask(taskRequestDto);
            }
            else {
                await sliderTaskService.updateTask(taskRequestDto);
            }

            toast.success(CustomerTaskConstants.TASK_SAVED_SUCCESSFULLY);
            //await fetchTasks();
            setFetchLatestTaskAt(new Date());
        }
        catch (ex) {

            if ((ex.status == 422 && ex.data?.error == CustomerTaskConstants.CUSTOMER_DELETED) || ex.status == 404) {
                toast.error(constant.CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
                return;
            }

            toast.error(CustomerTaskConstants.ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT);
            Logger.logError(CustomerTaskConstants.ERROR_WHILE_INITIALIZING_TASK_SLIDER_COMPONENT, ex);
        }
    }

    const cancelRowEditingClickHandler = async (originalRow: CustomerTaskDtoReadExtended, column: any) => {
        const result = await modalContext.showConfirmation(CustomerTaskConstants.ARE_YOU_SURE_TO_EXIT);
        if (!result) {
            return;
        }

        setTaskGridComponentState(compState => {

            compState.customerTasks.forEach(tsk => {
                tsk.isGridInEditMode = false;
            });

            let custTasks = [];
            if (originalRow.id) {

                // mark current row as readonly again.
                delete originalRow.editingRow;
                originalRow.enableGridRowEditing = false;

                custTasks = [...compState.customerTasks]
            }
            else {
                // Eliminate first rows without id. as user cancelled adding new customer task.
                custTasks = compState.customerTasks.filter((item) => item.id);
            }

            return { ...compState, customerTasks: custTasks, isRowDataAddedOrEdited: false };
        });
    }

    const editRowClickHandler = async (originalRow: CustomerTaskDtoReadExtended, column: any) => {
        let rowToEdit = CommonUtility.cloneObject(originalRow);

        // mark current row as editable.
        originalRow.editingRow = rowToEdit;
        originalRow.enableGridRowEditing = true;

        setTaskGridComponentState(compState => {
            compState.customerTasks.forEach(tsk => {
                tsk.isGridInEditMode = true;
            });
            return { ...compState, customerTasks: [...compState.customerTasks], isRowDataAddedOrEdited: true };
        });
    }

    return (
        <div className="cst-task-main-div">
            <Container fluid>
                <Row>
                    <Column lg={3} md={3}>
                        <Select
                            id="ddTaskStatus"
                            controlId="ddTaskStatus"
                            className="mb-3"
                            label={TaskScreenLables.status}
                            options={taskStatusList}
                            defaultSelected={taskStatusList?.filter(({ value }) =>
                                value === taskStatusId
                            )}
                            onChange={(values) => {
                                onComponentStateChange('taskStatusId', values[0] as string)
                            }}
                            placeholder={TaskScreenLables.pleaseSelect}
                            multiple={false}
                            disabled={taskGridComponentState.isRowDataAddedOrEdited}
                            tabIndex={1}
                        />
                    </Column>

                    <Column lg={3} md={3}>
                        <Select
                            id="ddTaskType"
                            controlId="ddTaskType"
                            className="mb-3"
                            label={TaskScreenLables.taskType}
                            options={taskTypeList}
                            defaultSelected={taskTypeList?.filter(({ value }) =>
                                value === taskTypeId
                            )}
                            onChange={(values) => {
                                onComponentStateChange('taskTypeId', values[0] as string)
                            }}
                            placeholder={TaskScreenLables.pleaseSelect}
                            multiple={false}
                            disabled={taskGridComponentState.isRowDataAddedOrEdited}
                            tabIndex={2}
                        />
                    </Column>
                    <Column lg={3} md={3} >
                        <Select
                            id="ddTaskPriority"
                            controlId="ddTaskPriority"
                            className="mb-3"
                            label={TaskScreenLables.priority}
                            options={taskPriorityList}
                            defaultSelected={taskPriorityList?.filter(({ value }) =>
                                value === taskPriorityId
                            )}
                            onChange={(values) => {
                                onComponentStateChange('taskPriorityId', values[0] as string)
                            }}
                            placeholder={TaskScreenLables.pleaseSelect}
                            multiple={false}
                            disabled={taskGridComponentState.isRowDataAddedOrEdited}
                            tabIndex={3}
                        />
                    </Column>
                    <Column lg={3} md={3} >
                        <div className="d-flex justify-content-end">
                            <Button
                                className="bt-main-action"
                                key="filter"
                                onClick={(e) => onAddTaskButtonClick()}
                                tabIndex={21}
                                id="btnAddCustomerTask"
                                disabled={taskGridComponentState.isRowDataAddedOrEdited || !canUserCreateCustomerTask}
                            >
                                <i className="bi bi-plus-circle me-2"></i>
                                {TaskScreenLables_Additional.addTasks}
                            </Button>
                        </div>
                    </Column>
                </Row>
            </Container>

            <div className="tsk-grd-div">
                <Grid
                    ref={gridRef}
                    data={customerTasks}
                    showFilters={false}
                    id={'customerTasksGrid'}
                    retainGridState={true}
                    columns={gridColumns}
                    hiddenColumns={['selection']}
                    sortDefault={[{ id: 'dueDaysFormatted', desc: false}]}
                    grdTabelClass='table-striped table-sm'
                    grdTableContainerClass='p-0 tsk-grd-table-container'
                    zindexHeader={10000}
                    navigateToFirstPage={navigateToFirstPage}
                    onNavigateToFirstPage={() => setNavigateToFirstPage(false)}
                />
            </div>
            <EntityHistoryViewer
                title={taskGridComponentState.historyDialogTitle}
                data={taskGridComponentState.taskHistoryData}
                columns={historyGridColumns}
                onClose={() => hideTaskHistoryModal()}
                show={taskGridComponentState.showTaskHistory}
                paginationDisabled={true}
                hiddenColumns={['selection']}
                entityHistoryMainDivClassName="task-history-grd-div"
                entityHistoryGrdTableContainerClass="task-history-table-container"
                modalClassName="task-history-modal">
            </EntityHistoryViewer>
        </div>
    );
}

export default CustomerTasksView;